import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, CssBaseline, Grid } from "@mui/material";
import LanguageSwitcher from "../components/LanguageSwitcher";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: '1px solid #3E3E3D33',
    padding: '0 20px'
  },
  profileImg: {
    height: "32px",
    width: "32px",
  },
  ImgContainer: {
    marginRight: "20px",
    marginTop: "10px",
  },
  languageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '10px'
  }
}));

export default function Header() {
  const classes = useStyles();
  return (
    <>
      <CssBaseline />
      <Grid container className={classes.root}>
        <Box></Box>
        <Box className={classes.languageContainer}>
          <LanguageSwitcher 
            customStyle={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} 
          />
        </Box>
      </Grid>
    </>
  );
}
